export default "__VITE_ASSET__Crso2xB2__"